import { Module } from "vuex";
import { RootState } from "../types";
import { CourseState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: CourseState = {};

const namespaced: boolean = true;

export const course: Module<CourseState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
